export default __webpack_public_path__ + "static/media/BVI-Logo.91a278c5.jpeg";